import './sendIntimation.css';
import React, { useState, useEffect } from 'react';

import { SEND_INTIMATION } from '../../common/URLs';
import { useNavigate } from 'react-router-dom';
import { FILE_NAME_VALIDATION_ERROR, MESSAGES } from '../../common/constants';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import { Card, Button, CardContent, Box, Typography } from '@mui/material';
import { Download as  DownloadIcon } from '@mui/icons-material';
import { fileNameValidation } from '../../common/commonValidations';
import { toast } from 'react-toastify';
import { loaderService } from '../../common/custom-loader/loader-service';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { SubmitIcon } from '../../common/icons';
import apiClient from '../../axios';

const div_intimation_style = {

    top: "10vh",
    left: "29vw"
}

export default function SendIntimation() {

    const [selectedFile, setSelectedFile] = useState();
    const [uploadDetails, setUploadDetails] = useState();
    const [fileintimationError, setFileintimationError] = useState('');
    const navigate = useNavigate();
    const extensionList = ['xls', 'xlsx', 'xlsm'];
    const [logModalOpenSubmit, setLogModalOpenSubmit] = useState(false);
    const handleLogModalCloseSubmit = () => setLogModalOpenSubmit(false);
    const [isApiCalled, setIsApiCalled] = useState(false);
    const handleLogModalOpenSubmit = () => setLogModalOpenSubmit(true);
    useEffect(() => {

        if (uploadDetails) {
            if (uploadDetails?.data?.isSuccess === true) {
               toast.success(MESSAGES?.PRE_REG_SUCCESS);
               navigate('../dashboard')
            }
            else if (uploadDetails?.data?.isSuccess === false) {
                toast.error(uploadDetails?.data?.message);
            } 
            else {
                toast.error(uploadDetails?.data + ": Add relevant file");
            }
        }

    }, [uploadDetails]);

    const handleChange = (e) => {
        setFileintimationError('');
        setSelectedFile(e.target.files[0])
    };

    // const onConfirmSubmit = () => {
    //     handleLogModalCloseSubmit();
    //     sendIntimation();
    // }

    
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await sendIntimation();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpenSubmit(false);
            setIsApiCalled(false);
        }
    };

    const onSubmit = (e) => {
        if (selectedFile) {
            const extension = selectedFile.name.split('.').pop().toLowerCase();
            const isXlsFile = !!extension && extensionList.includes(extension);
            if (!isXlsFile) {
                setFileintimationError("Only .xls, .xlsx, .xlsm files are allowed.");
                return;
            }
            else if (selectedFile.name.split('.').length > 2) {
                setFileintimationError("Double extension file detected.");
                return;
            }
            else if (selectedFile.size >= 5000000) {
                setFileintimationError("The file size should be less than 5MB.");
                return;
            }
            else if (fileNameValidation(selectedFile.name)) {
                setFileintimationError(FILE_NAME_VALIDATION_ERROR);
                return;
            }
            else {
                handleLogModalOpenSubmit();
                e.preventDefault();
            }
        }
    };

    function sendIntimation() {
        loaderService.showLoader();
        const formData = new FormData();
        formData.append("file", selectedFile);
        apiClient
            .post(SEND_INTIMATION, formData,
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }
            )
            .then((response) => {
                setUploadDetails(response)
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                setUploadDetails(error?.response)
                loaderService.hideLoader();
            });
    }

    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                        Send intimation
                    </Typography>
                    <a style={{ display: "flex", flexDirection: "row" }} href='https://abrplscmsandbox.blob.core.windows.net/stakeholdertemplate/SendIntimationTemplate.xlsm'>
                        <DownloadIcon /> <Typography variant="subtitle1">Download Send-Intimation Template.</Typography></a>
                    <Typography variant="subtitle2" mt={2}>Upload send-intimation file</Typography>
                    <Box mt={1}>
                        <label className="ChooseFileInputAdminPincode">
                            <input style={{ fontSize: '2vh' }} type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => handleChange(e)} name="Bulk_intimation" />
                        </label>
                        <Typography variant="subtitle2" fontSize="1.8vh" color="green">(upload only .xls, .xlsx, .xlsm files.File size limit=5MB)</Typography>
                        <Typography variant="subtitle2" fontSize="1.8vh" color="red">{fileintimationError}</Typography>
                    </Box>
                    <Box display='flex' alignItems="center" justifyContent="center" mt={3} mb={1}>
                        <Button endIcon={<SubmitIcon/>} sx={{ minWidth: 100 }} variant="contained" name="excel_intimation" onClick={(e) => onSubmit(e)}>Submit</Button>
                    </Box>
                </CardContent>
            </Card>
            <ConfirmationPopover onOpen={logModalOpenSubmit} onConfirm={onConfirmSubmit} action="Submit" onClose={handleLogModalCloseSubmit} />
       
        </>
    );
}